import React from 'react';
import PropTypes from 'prop-types';
import Charts from './Charts';
import { renderTooltip } from '../../../util/QuickReportsUtils';

const LineChart = ({
  chartTitle,
  chartColor,
  categories,
  xAxisLabel,
  yAxisText,
  data,
  legend,
  tickPlacement,
}) => {
  const config = {
    title: {
      text: chartTitle,
      align: 'left',
      margin: 25,
      style: {
        fontSize: '18px',
        color: '#80a4c5',
      },
    },
    legend,
    colors: chartColor,
    xAxis: {
      categories,
      tickmarkPlacement: tickPlacement,
      labels: {
        style: {
          textOverflow: 'none',
          fontSize: '10px',
          color: '#30435d',
          textAlign: 'center',
        },
        enabled: xAxisLabel,
      },
      gridLineColor: 'transparent',
    },
    yAxis: {
      title: {
        text: yAxisText,
      },
      labels: {
        style: {
          fontSize: '10px',
          fontWeight: 'bold',
          color: '#30435d',
        },
      },
      gridLineColor: '#bbc6d5',
    },
    tooltip: {
      useHTML: true,
      followPointer: true,
      headerFormat: '<b><span>{point.key}</span></b><br />',
      pointFormat: renderTooltip(data.tooltip),
      backgroundColor: '#fff',
      padding: '0',
      borderColor: 'RGB(71, 100, 138)',
      borderRadius: 6,
    },
    series: data.series,
  };
  // console.log(config);
  return <Charts config={config} />;
};

LineChart.propTypes = {
  chartTitle: PropTypes.string,
  chartColor: PropTypes.arrayOf(PropTypes.string),
  xAxisLabel: PropTypes.bool,
  data: PropTypes.shape({}),
  yAxisText: PropTypes.string,
  labelFormatter: PropTypes.shape({}),
  dataLabelPosition: PropTypes.shape({}),
  legend: PropTypes.shape({}),
  tickPlacement: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.string),
};

LineChart.defaultProps = {
  chartTitle: '',
  chartColor: ['#e5cf8e'],
  xAxisLabel: true,
  yAxisText: null,
  dataLabelPosition: {},
  tickPlacement: 'between',
};

export default LineChart;
